import { Moon, Sun } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTheme } from '@/theme/use-theme';

/**
 * Header icon toggle between light and dark theme. Sits next to the
 * LocaleSwitcher per the design-doc §10 mapping (terminals use the
 * same `nightlight_round` / `wb_sunny_outlined` semantic pair).
 */
export function ThemeSwitcher() {
  const { mode, toggle } = useTheme();
  const Icon = mode === 'dark' ? Sun : Moon;
  const label = mode === 'dark' ? 'Switch to light theme' : 'Switch to dark theme';

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      onClick={toggle}
      aria-label={label}
      title={label}
    >
      <Icon className="h-4 w-4" />
    </Button>
  );
}
